var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"legal"},[[_vm._v(" Kérünk, vedd figyelembe, hogy szerződésedre az annak kezdete időpontjában hatályos biztosítási feltételek vonatkoznak. ")]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }